export const toTitleCase = (str = "") => {
  if (typeof str !== "string") return "";
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};
